import { useTranslation } from "react-i18next";

export const useI18typeProxy = () => {
  const { t } = useTranslation();

  const types = [
    {
      id: "MobileProxy",
      name: t("typeOfProxy.name.1"),
    },
    {
      id: "IPv4",
      name: t("typeOfProxy.name.2"),
    },
    {
      id: "ResidentialProxy",
      name: t("typeOfProxy.name.3"),
    },
    {
      id: "ISP",
      name: t("typeOfProxy.name.4"),
    },
    {
      id: "IPv6",
      name: t("typeOfProxy.name.5"),
    },
    {
      id: "SharedProxy",
      name: t("typeOfProxy.name.6"),
    },
    {
      id: "RemoteServer",
      name: t("typeOfProxy.name.7"),
    },
  ];

  return { types };
};
